import { render } from "./Social.vue?vue&type=template&id=ebd3b746&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=ebd3b746&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd3b746"]])

export default __exports__